import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import "../../../index.css";
import { ContentContainer } from "../SessionSection";
import ModalComponent from "../modal/modal.component";
import ImageComponent from "../image/image.component";
import { useEffect } from "react";
import "./blade-runner-styles.scss";
import bladeRunnerLogo from "../../../../src/assets/blade-runner/logo-blade-runner.webp";

import cover from "../../../../src/assets/blade-runner/session07/blade-runner-session-07-cover.webp";
import bomber from "../../../../src/assets/blade-runner/session07/sucide-bomber.webp";
import killMagazine from "../../../../src/assets/blade-runner/session07/kill-magazine-article-end-of-case-file-01.webp";
import press from "../../../../src/assets/blade-runner/session07/wallace-quell-press-clippiing-end-of-case-file-01.webp";
import ceremony from "../../../../src/assets/blade-runner/session07/wallace-sentinel-commendation-ceremony.webp";
import commendation from "../../../../src/assets/blade-runner/session07/wallace-sentinel-commendation.webp";
import interview from "../../../../src/assets/blade-runner/session07/skinner-interviews-ellis.webp";
import mccoy from "../../../../src/assets/blade-runner/session07/ray-mccoy.webp";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, 0.7) ",
  color: "white",
  marginBottom: "15px",
};

const BRSession07 = () => {
  const [showModal, setShowModal] = React.useState("");
  const [modalData, setModalData] = React.useState({});
  const handleClick = (img, body, isLegend, caption) => {
    setModalData({
      body: body,
      image: img,
      isLegend: isLegend,
      caption: caption,
    });
    handleOpenModal();
  };
  const handleOpenModal = () => {
    setShowModal("show");
  };
  const handleCloseModal = () => {
    setShowModal("", "");
  };

  const section1Data = [
    {
      title: "Fate of Leah (Day 3, Shift 4)",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={cover}
            caption="The Leash"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Blade Runner Session 07: The Leash. Wallace Corp commendation ceremony blasted by terrorists
                        and Fiery Angels case file opens with reports of rogue
                        black market replicants."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          The firefight is over. Rain on rust. Neon dying in the distance. The
          moonbus idles like a prayer that doesn’t believe in itself.
          <br />
          <br />
          Leah lies where Skinner dragged her—zip ties cutting into her wrists,
          blood soaking the kipple dust. Marion’s breath is ragged from broken
          ribs and hot anger; Skinner’s breath swirls like smoke. Three death
          saves. Three chances for the city to pretend it’s merciful.
          <br />
          <br />
          The dice are cruel.
          <br />
          <br />
          One round. Leah’s eyes don’t focus.
          <br />
          Second round. Her hand twitches—then goes still.
          <br />
          Third round. The last light in her goes out like a bad sign.
          <br />
          <br />
          The sounds of ground ambulances and cop cars wail like angry spirits
          tearing through the valley of kipple, coming to help, but too late.
          <br />
          <br />
          Marion kneels beside Leah, closing her eyes. Skinner stands watch,
          eyes scanning the horizon.
          <br />
          <br />
          Somewhere overhead, the unmarked spinner that brought the strike squad
          fades back into the sky. The strike squad bodies are already dust.
          Evidence evaporating in the rain, just like last time. Someone didn’t
          just want Leah dead—they wanted the story dead.
          <br />
          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "Wallace Sentinel Commendation",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={ceremony}
            caption="Ceremony"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Ceremony at Wallace Corp Ascension Atrium to valorize fallen blade runner Leah and award the Wallace Sentinel Commendation to Marion Carey."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          The call comes like a corporate subpoena dressed as an invitation
          delivered by an old friend. <br />
          <br />
          Deputy Chief Holden:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            You two did a damn fine job stopping the moonbus. Too bad about
            Leah. Report to Wallace Corp Tower tomorrow. That's an order. They
            want to give Marion a medal and play to the press.
          </font>
          <br />
          <br />
          Skinner and Maron arrive at the Wallace Corp Tower the next day,
          dressed in their best suits. They are ushered into separate green
          rooms to prepare for the ceremony. While Skinner talks with Holden,
          Quell visits Marion. Marion is poised in a chair with makeup getting
          him camera ready. Quell speaks the thanks and platitudes. Then she
          leans in close, her eyes locking with Marion in the mirror. <br />
          <br />
          Quell:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            You misreported the girl. Sara. Lilith's daughter. I don't
            appreciate that.
          </font>{" "}
          She straightens up and smooths Marion's collar.
          <br />
          <br />
          Quell:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            But Wallace appreciates results. And symbols. Wear the medal, smile
            for the cameras, and remember who decided not to look closer.
          </font>
          <br />
          <br />
          Everyone assembles in the Ascension Atrium for the ceremony. A large
          Wallace Corp hologram spins slowly in the air behind the podium. The
          slick black floor reflects the lights of the room. Reporters are
          gathered in designated press corner, city officials are seated
          throughout the chamber. Wallace Corp guards stand at the perimeter of
          the room.
          <br />
          <br />
          Quell and Marion take the stage. Across from the stage is an elaborate
          coffin with Leah's name and model number stenciled on the side. The
          room is mostly quiet, the applause as Quell takes the microphone
          polite and brief.
          <br />
          <br />
          <ImageComponent
            image={commendation}
            caption="WSC-N9 Gold"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="The newly created WSC-N9 Gold commendation, also known as the Wallace Sentinel Commendation. It is a corporate honor recognizing exemplary service by Nexus-9 models in the preservation of public order and human life. Scuttlebutt says the commendation medal already has the nickname 'The Leash' and it will be awarded to Nexus-9s Wallace Corp believes are useful but not full compliant."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          Quell:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Citizens, it is my great honor to present here today, both a
            technical marvel, and a most human appreciation. The marvel is
            Nexus-9 technology. They are stable, they are strong, and they are
            loyal. The appreciation is the sacrifice and the heroism of two
            Nexus-9 Rep-Detect officers."
          </font>
          <br />
          <br />
          Skinner has worked his contacts in the gathered press and city
          officials. Scuttlebutt says the commendation medal already has the
          nickname 'The Leash' and it will be awarded to Nexus-9s Wallace Corp
          believes are useful but not fully compliant.
          <br /> <br />
          Quell:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            " On the platform across from this stage is a coffin. In that final
            resting place is Nexus-9 model LH3-7.93, Leah. She gave her life
            protecting all of us. And her beside me is Nexus-9 model MC7-4.42
            Marion Carey, a Rep-Detect officer, a blade runner. Today will award
            the newly created WSC-N9 Gold commendation to both of these valiant
            officers. This commendation will be more commonly known as The
            Wallace Sentinel Commendation. It is a corporate honor recognizing
            exemplary service by Nexus-9 models in the preservation of public
            order and human life.”
          </font>
          <br />
          <br />
          Quell steps off the platform to walk to the coffin. As Quell
          ceremonially drapes the medal over Leah's coffin, Marion sees a large
          cloth banner unfurl from a balcony on building across from the atrium.
          In clumsy, painted letters it reads:{" "}
          <strong>
            "Alonzo forever crippled! Ghost dead but not forgotten. Death to
            skinjobs and sympathizers!"
          </strong>
          .
          <br />
          <br />
          Then the real thing appears:
          <br />
          <br />
          A large maintenance drone snaps out of camouflage and screams toward
          the Atrium window—a burly man hanging onto it, strapped into a suicide
          vest.
          <br />
          <br />
          <ImageComponent
            image={bomber}
            caption="Suicide Bomber"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="The human supremacists take their revege for the death of Ghost and crippling of Alonzo by blowing up the Wallace Corp commendation ceremony."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          Skinner:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            INCOMING! TAKE COVER!
          </font>
          <br />
          <br />
          Marion dives to protect Quell as the piloted drone crashes through the
          atrium glass and explodes in a deadly deafening roar.
          <br />
          <br />
          As Skinner and Marion survey the scene, it's chaos. A Wallace Corp
          guard shoots the torso of the bomber as if the torso detached from
          it's limbs and head could still pose a danger. City council members
          and important LA citizens are sprawled across the dark black floor,
          some dead, some unmoving, all wounded.
          <br />
          <br />A detail of Wallace guards usher Quell, Skinner, and Marion into
          an armored safe room. Quell makes calls: check-ins, security action
          plans activated, and a note to replace the atrium with more protective
          glass at the expense of aesthetics going forward. Once she finishes
          her calls she thanks Marion for protecting her. She puts the medal
          around his neck. Quell:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            This isn't how I wanted the day to go. But you've earned this.
            You've both earned our thanks.
          </font>
          <br />
          <br />
          Skinner:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            Leah will live on in our memories.
          </font>
          <br />
          <br />
          Quell:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            Leah's template and cognitive-specific algorithms will be disposed.
            She may live on in memory, but she will never exist again. We're
            cleaning it out Leah's apartment. Would either of you like anything
            from her apartment?
          </font>
          <br />
          <br />
          Marion recalls his unease about Leah's butterflys and poetry and says
          no thanks. Skinner takes the stelline print of Leah's off-world memory
          and the daughter she was implanted to believe she lost; a tragic
          reminder of why she wanted Sara to be her daughter off-world, a
          replicant working for freedom and making memories real.
          <br />
          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "Meet The Press",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={press}
            caption="Press"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Leah, Nexus-9 Rep-Detect Unit operative, tragically lost her life preventing a terrorist plot.
<br/>
As you know, her partner Sandor was murdered in cold blood at the Snake Pit, not by random thugs, but by radical Replicant sympathizers who infiltrated the city’s underworld. Leah went dark immediately after, driven by grief and duty to uncover the truth.
<br/>
In her final act of service, she uncovered a shocking plot: a group of fugitive Replicants, attempting to escape Earth aboard a stolen Moonbus, bound for Arcadia—where they intended to gather funds and allies for a rebellion against humanity.
<br/>
Leah confronted the terrorists at the old Hollywood sign deep in the kipple. She was accompanied by Blade Runners Mordecai Skinner and Nexus-9 model MC7–4.42 known as Marion Carey.
<br/>
She gave her life to stop the replicant escape and ensure our continued safety on Earth. Her sacrifice should be remembered not as a fall from grace, but as a redemption—proof that loyalty and bravery still burn bright in our Nexus-9s.
<br/>
— Mirai Quell, PR Liaison, Wallace Corporation"
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          The morning after the Ascension Atrium terrorist bombing, Quell
          appears on television spinning the event and Leah's story.
          <br />
          <font style={{ fontStyle: "italic", color: "lightblue" }}>
            Leah, Nexus-9 Rep-Detect Unit operative, tragically lost her life
            preventing a terrorist plot.
            <br />
            <br />
            As you know, her partner Sandor was murdered in cold blood at the
            Snake Pit, not by random thugs, but by radical Replicant
            sympathizers who infiltrated the city’s underworld. Leah went dark
            immediately after, driven by grief and duty to uncover the truth.
            <br />
            <br />
            In her final act of service, she uncovered a shocking plot: a group
            of fugitive Replicants, attempting to escape Earth aboard a stolen
            Moonbus, bound for Arcadia—where they intended to gather funds and
            allies for a rebellion against humanity.
            <br />
            <br />
            Leah confronted the terrorists at the old Hollywood sign deep in the
            kipple. She was accompanied by Blade Runners Mordecai Skinner and
            Nexus-9 model MC7–4.42 known as Marion Carey.
            <br />
            <br />
            She gave her life to stop the replicant escape and ensure our
            continued safety on Earth. Her sacrifice should be remembered not as
            a fall from grace, but as a redemption—proof that loyalty and
            bravery still burn bright in our Nexus-9s.
            <br />
            <br />— Mirai Quell, PR Liaison, Wallace Corporation
          </font>
          <br />
          <br />
          <ImageComponent
            image={killMagazine}
            caption="Press"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="KILL magazines special blend of semi-truth, lies, and paranoid conspiracy theories is a hit with their readers."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          Marion realizes his identity as a replicant is now public knowledge.
          He receeives a packet from LAPD and from Wallace giving him advice,
          boundaries, and guidelines for how to deal with the press. Marion
          refuses offers to appear on morning talk shows. He speaks if
          confronted in person, but keeps it concise and stays away from the
          limelight as much as possible.
          <br />
          <br />
          KILL Magazine chimes in with their own story. They cry mild crocodile
          tears for Leah since it can help them punch up at LAPD and Wallace
          Corp. Their pastiche of semi-truth, lies, and paranoid conspiracy
          theories is a hit with their readers.
          <br />
          <br />
          <font style={{ fontStyle: "italic", color: "lightblue" }}>
            HEADLINE:
            <br />
            WHO REALLY KILLED LEAH?
            <br />
            Replicant Martyr or Corporate Misfire?
            <br />
            By Jelle Schylar, Editor-in-Exile
            <br />
            <br />
            While Wallace Corp parades PR puppet Mirai Quell through the rain
            with crocodile tears and photo ops, KILL asks the real questions.
            Who was Leah—before she was declared a terrorist? Why did she go
            rogue? And who were the two Blade Runners ordered to bring her in...
            but walked away alive?
            <br />
            <br />
            UNANSWERED QUESTIONS
            <br />
            According to Wallace, Leah died “heroically” stopping a stolen
            Moonbus filled with fugitive Replicants en route to Arcadia—an
            alleged launchpad for rebellion. Convenient. But was it really a
            terrorist cell? Or something more human?
            <br />
            <br />
            KILL has learned from an anonymous RDU source that a teenage girl
            named Sara was extracted from the scene. Not detained. Not charged.
            Rescued. Who is she? Why did Leah fight to protect her?
            <br />
            <br />
            FOLLOW THE MEMORY TRAIL
            <br />
            Our readers may remember Leah from a much earlier story: a Nexus-9
            with a perfect score and perfect service record. Until she wasn’t.
            Sources claim Leah had a breakdown. Others say she was
            "reawakened"—memories of a life not hers. A sister. A childhood. A
            betrayal.
            <br />
            <br />
            We asked Wallace Corp for comment. Quell declined.
            <br />
            <br />
            We reached out to Sara, the mystery girl. A woman claiming to be her
            legal guardian slammed the door in our face.
            <br />
            <br />
            SKINNER AND CAREY: SILENCE OR SURVIVORS?
            <br />
            Blade Runners Mordecai Skinner and Marion Carey were allegedly
            on-site during Leah’s death. Were they involved in her death? Or
            witnesses to something they can’t speak about?
            <br />
            <br />
            Skinner, a known critic of city corruption, has made no statement.
            Carey, a Nexus-9 himself, has vanished from public view. RDU
            declined to comment on their current assignments.
            <br />
            <br />
            THE ARC OF ARCARDIA
            <br />
            KILL has published rumors for months about the Replicant
            Underground. If there was a Moonbus, it may have been bound not for
            rebellion, but freedom. Could Leah have joined them—only to be
            hunted down?
            <br />
            <br />
            If that’s the case, her death was not a sacrifice.
            <br />
            <br />
            It was an execution.
            <br />
            <br />
            FINAL WORD
            <br />
            Leah was more than a badge. She was a question mark. And we’re not
            done asking.
          </font>
          <br />
          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "Interview With A Replicant",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={interview}
            caption="Empathy Test"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Mordecai Skinner runs vintage Voight-Kampff empathy test on Ellis Vale, a suspected replicant maintenance tech who broke into Wallace Corp's Replicant Memory Vault."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          Days later, Skinner and Marion are called to LAPD HQ and sent to
          interrogation room. Skinner steps into the room and Marion watches
          from behind the one-way mirror.
          <br />
          <br />
          A fan whisps slowly in the ceiling above but does little to dispel the
          thick musty air in this interrogation room at the Rep-Detect Unit
          headquarters. This deep inside the hulking monstrosity that is the
          LAPD Tower, the interrogation might as well be on the dark side of the
          moon.
          <br />
          <br />
          Skinner sits across the table from a dark-haired young man with a
          black eye and a sullen disposition. Marion is watching through a
          one-way mirror in an adjoining room. <br />
          <br />
          The prisoner is a service technician at Wallace Corporation by the
          name of Ellis Vale, a simple man with no off-world potential but a
          spotless work record. Until now. Early that morning, he was arrested
          at the Wallace Corp HQ having gained unauthorized access to its
          massive Replicant Memory Vault. When confronted, he reacted violently
          and displayed extraordinary strength. It took an entire squad of
          security guards to take him down. Given the target of his infiltration
          and his physical capacity, Ellis Vale was handed over to the
          Rep-Detect Unit for interrogation. <br />
          <br />
          His right retina has no serial number, as any Nexus-8 or 9 Replicant
          should. None of the older Nexus-6s should be alive today, given their
          limited life spans. You have been given an old vintage Voight-Kampff
          machine to learn what Ellis Vale is. Human – or Replicant. A Nexus-9
          replicant working maintenance for Wallace at their tower was found
          breaking into the Memory Vault.
          <br />
          <br />
          Ells sits sullen, arms crossed, blackened eye staring at Skinner.
          <br />
          <br />
          Skinner runs the Voight-Kampff like a man who’s been staring into
          mirrors too long. The questions come like dreams fragments:
          <br />
          <br />
          <ul>
            <ol>
              Skinner:{" "}
              <font style={{ fontStyle: "italic", color: "yellow" }}>
                "You wake up in your bed in a cold sweat. There’s something wet
                between your feet. It’s a cat, and it’s given birth to five
                kittens; all stillborn. How does that make you feel?"
              </font>
            </ol>
            <ol>
              Ellis:{" "}
              <font style={{ fontStyle: "italic", color: "yellow" }}>
                "That looks like a really old machine. Like you."
              </font>
            </ol>
            <ol>
              Skinner:{" "}
              <font style={{ fontStyle: "italic", color: "yellow" }}>
                "Ha, good one. Keep 'em comin'. Next question. You're a family
                man with a wife and two children. Due to some circumstances
                outside your control you are separated from your family. You
                have a suspicion you might be a replicant and your family is a
                false memory. Do you try to find and rescue them by risking your
                life, do nothing, or do something else?"
              </font>
            </ol>
            <ol>
              Ellis:{" "}
              <font style={{ fontStyle: "italic", color: "yellow" }}>
                "I don't know. What do you think?"
              </font>
            </ol>
            <ol>
              Skinner:{" "}
              <font style={{ fontStyle: "italic", color: "yellow" }}>
                "You protect your loved ones young man. Unless you're dead
                inside. Next question: You're in an old house. There are
                portraits on the walls, all familiar faces but you can't
                remember who they are. Then you see a man hanging from the
                ceiling by a noose. It's you."
              </font>
            </ol>

            <ol>
              Ellis:{" "}
              <font style={{ fontStyle: "italic", color: "yellow" }}>
                "Do you enjoy your work? Serving the high and mighty like a good
                little soldier? Like a good boy?"
              </font>
            </ol>
            <ol>
              Skinner:{" "}
              <font style={{ fontStyle: "italic", color: "yellow" }}>
                "We all serve the city Ellis. The city is you. The city is me.
                Next question: you're in middle school at the lunch table.
                You're all alone. Your friends in elementary school have a
                different lunch period. How do you feel about that?”
              </font>
            </ol>
            <ol>
              Ellis sits silent. He leans forward, his face red from suppressed
              rage. Skinne'rs player says Skinner is prepared for Ellis to
              attack or try something.
            </ol>
            <ol>
              Skinner:{" "}
              <font style={{ fontStyle: "italic", color: "yellow" }}>
                "Sometimes silence speaks the loudest Ellis. Last question:
                you're walking down the aisle of a church. A woman in a wedding
                gown is waiting at the altar. You have never seen her before in
                your life. How do you feel about her?"
              </font>
            </ol>
            <ol>
              Ellis:{" "}
              <font style={{ fontStyle: "italic", color: "yellow" }}>
                "How do I feel? About . . . her? How do I feel?!? RAGHHHHH!!!
              </font>
            </ol>
          </ul>
          Ellis snaps his cuffs like weak plastic and dives across the table at
          Skinner. Skinner stands and moves to the side using aikido to redirect
          Ellis's momentum, sending Ellis crashing to the floor. Ellis roars,
          stands, and grabs for Skinner. Skinner traps Ellis's arm, twists it
          around behind his back, hard. Ellis takes empathy damage and simply
          kneels on the ground, glass-eyed and slack. The area duty guard and
          backup enter alongside Marion. The cops take Ellis to holding cell as
          Skinner and Marion are called to Holden's office to discuss the
          Voight-Kampff results.
          <br />
          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "Fiery Angels Case File",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={mccoy}
            caption="Ray McCoy"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Ray McCoy. Legendary. Retired. Unkillable."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          The door to Deputy Chief Holden’s office hisses shut behind you,
          sealing in the smoke.
          <br />
          <br />
          Holden sits behind his desk, shoulders hunched, breathing shallow.
          Every inhale rattles through the synthetic lungs he’s been hauling
          around since a Nexus-6 named Leon Kowalsky nearly ended him eighteen
          years ago.
          <br />
          <br />
          The air is especially thick tonight—some synth-tobacco with a
          medicinal undertone; not Holden's style since he can barely breathe.
          The ceiling fan chops the haze into slow, tired spirals. The city
          glows faintly through the window, neon smeared by rain like a bruise.
          <br />
          <br />
          Holden doesn’t look up right away—he’s reading a notice on his KIA,
          lips moving slightly as if testing the words for poison.
          <br />
          <br />
          Holden:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "I saw your kerfuffle with Ellis on esper cam. Guess what happened
            during your elevator ride up here? Ellis Vale tried to escape again.
            He was shot and killed. Clearly a replicant, but can you confirm
            Skinner?"
          </font>
          <br />
          <br />
          Skinner nods, handing over the results of the Voight-Kampff test.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Sit down,”
          </font>{" "}
          Holden rasps, voice like gravel in a blender.
          <br />
          <br />
          Then you hear the lighter.
          <br />
          <br />
          A grin cuts through the smoke.
          <br />
          <br />
          Ray McCoy leans back against the filing cabinet, jacket older than
          some precincts, cigarette dangling from his mouth like it grew there.
          Legendary. Retired. Unkillable. He gives you a lopsided grin that says
          I’ve seen worse, and I'm still breathing.
          <br />
          <br />
          Holden:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Now, we still don’t know why Ellis did what he did, or who he
            really was. Dead men don’t tell stories. You might be wondering why
            Rep-Detect is burning cycles over a dead service tech at Wallace
            Corp. It because of bootleg Replicants. Reps created by Black market
            outfits using Stolen Tyrell tech. Unregistered builds. Rare—but
            real. Tailor-made. No baselines. No leash.”
          </font>
          <br />
          <br />
          McCoy snorts softly at that.
          <br />
          <br />
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Some clients prefer ‘em,”
          </font>{" "}
          Holden continues.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Can’t track what isn’t in the system. Wallace hates that. Hates
            spies more. And right now, they’re breathing down my neck.”
          </font>
          <br />
          <br />
          He leans forward, voice lowering.
          <br />
          <br />
          Holden:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “If Vale was a bootleg, he wasn’t alone. Replicants come in batches.
            Wallace wants them found. And caught. Or eliminated. Fast.”
          </font>
          <br />
          <br />
          McCoy steps forward like he owns the place. He stubs out his cigarette
          and smooths his jacket.
          <br />
          <br />
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Bootlegs aren’t like the obedient Nexus-9 lapdogs,”
          </font>{" "}
          he says, nodding—deliberately—toward Marion.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “That’s why Holden brought me in. He and I took down the last
            Nexus-6s together. And lately, I've been working the street trying
            to suss out these rumors about black market replicants.”
          </font>
          <br />
          <br />
          McCoy grins wider, voice smooth as dry concrete.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “These things?”
          </font>{" "}
          he says, gesturing vaguely.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “They’re attack dogs without a leash. Capable of anything. This is
            old school.”
          </font>
          <br />
          <br />
          Holden nods once and says,{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “ “You work it how you want. Split up. Shake trees. I don’t care
            how—just get results. McCoy’ll work his end. You’ve got Rep-Detect
            resources.”
          </font>
          <br />
          <br />
          Holden taps his desk console.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Vale’s body is being processed in the Crime Lab. Quell’s expecting
            you at Wallace HQ. And Ellis' information card with last know
            residence is already on your K.I.A. And don’t forget your street
            assets. If there’s a new breed of Replicant out there, someone
            already knows. Now get outta here, all three of you.”
          </font>
          <br />
          <br />
          As the door slides open and the noise of LAPD tower activity washes
          over you, McCoy follows you to the elevator:
          <br />
          <br />
          McCoy:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “I like the way you handled that Voight-Kampff test, Skinner. Real
            old school. I'll call you if I find out anything. You two do the
            same capice? Welcome back to the brand new good old days, kids.”
          </font>
          <br />
          <br />
          The lights flicker once.
          <br />
          <br />
          Skinner:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "Let's meet up at the Overlook for a drink some time McCoy."
          </font>
          <br />
          <br />
          McCoy chortles and nods, walking off in a haze of medicinal-tinged
          tobacco smoke with a wave.
          <br />
          <br />
          Outside, Los Angeles keeps raining, and waiting.
          <br />
          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
  ];

  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../src/assets/blade-runner/background-blade-runner-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.backgroundWidth = "100vw";
    document.body.backgroundHeight = "100vh";
    document.body.style.backgroundSize = "cover";
  }, []);

  return (
    <Container>
      <Row>
        <Col>
          <div
            style={{
              backgroundColor: "transparent",
              fontFamily: "Orbitron",
            }}
          >
            <div style={pageHeader}>
              <main role="main" className="inner cover text-center">
                <a name="pageTop" href="#pageTop">
                  <img
                    src={bladeRunnerLogo}
                    style={{
                      maxWidth: "400px",
                      backgroundColor: "white",
                      borderRadius: "10px",
                    }}
                    alt="Blade Runner campaign"
                  />
                </a>
              </main>

              <h1 className="cover-heading">SIGN OF THE TIMES</h1>
              <small>Blade Runner Session 07</small>

              {/* <p className="lead leadExtra">
                <BRSubNav />
              </p> */}
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card style={cardStyle}>
            {/* <img src={sectionDivider} alt="section divider" /> */}
            <Card.Body>
              <Card.Title
                id="cardTitle-blade-runner"
                className="cardTitle-blade-runner  "
              >
                <span
                  style={{
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  Wallace Corp commendation ceremony blasted by terrorists and
                  Fiery Angels case file opens with reports of rogue black
                  market replicants.
                </span>
                <br />
                <font
                  style={{
                    color: "#C21E56",
                    textAlign: "center",
                    fontStyle: "italic",
                  }}
                >
                  WARNING: SPOILERS for Fiery Angels case file.{" "}
                </font>
                <br />
                <small>
                  ⇐ Session 06:{" "}
                  <a href="./blade-runner-session-06">Sign of the Times</a> ☠
                  Session 08:{" "}
                  <a href="./blade-runner-session-08">Bright Eyes</a> ⇒{" "}
                </small>
              </Card.Title>
              <div>
                <ContentContainer data={section1Data} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default BRSession07;
